import { Spin, Table, Typography } from 'antd';
import React from 'react';
import './PricingOptionsTable.scss';
const { Link } = Typography;
const PricingOptionsTable = ({
  data,
  current,
  totalCount,
  onPaginationChange,
  fetching,
  offset,
  onPriceClick
}) => {
  const columnsCollection = {
    noIndex: {
      title: 'No',
      dataIndex: 'index',
      key: 'index',
      render: (value, record, index) => {
        const label = <span>{offset + index + 1}</span>;
        return label;
      }
    },
    total: {
      title: 'Global Price',
      render: (value, record) => {
        return (
          <Link onClick={() => onPriceClick(record)}>
            {record?.currency} {record?.total}
          </Link>
        );
      }
    },
    deposit: {
      title: 'Deposit',
      render: (value, record) => {
        return (
          <span>
            {record?.deposit?.value}{' '}
            {record?.deposit?.type == 'percent' ? '%' : record?.currency}
          </span>
        );
      }
    },
    localiseForAllCountries: {
      title: 'Localised For All Countries',
      dataIndex: 'localiseForAllCountries',
      key: 'localiseForAllCountries',
      render: (value, record) => {
        return (
          <span>{record?.localiseForAllCountries ? 'Yes' : 'No'}</span>
        );
      }
    },
    isDiffrentialPricing: {
      title: 'Diffrential Pricing Defined',
      render: (value, record) => {
        return (
          <span>
            {record?.countryWisePrice && record?.countryWisePrice?.length
              ? 'Yes'
              : 'No'}
          </span>
        );
      }
    },
    discountEnabled: {
      title: 'Discount Enabled',
      dataIndex: 'discountEnabled',
      key: 'discountEnabled',
      render: (value, record) => {
        return <span>{record?.discountEnabled ? 'Yes' : 'No'}</span>;
      }
    },
    type: {
      title: 'Type/Tag',
      dataIndex: 'type',
      key: 'type',
      render: (value, record) => {
        return <span>{record?.type}</span>;
      }
    },
    creditsEnabled: {
      title: 'Credits Enabled',
      dataIndex: 'creditsEnabled',
      key: 'creditsEnabled',
      render: (value, record) => {
        return <span>{record.creditsEnabled ? 'Yes' : 'No'}</span>;
      }
    }
  };

  const renderColumns = () => {
    const columns = [
      'noIndex',
      'total',
      'deposit',
      'localiseForAllCountries',
      'isDiffrentialPricing',
      'discountEnabled',
      'type',
      'creditsEnabled'
    ];
    return columns.map((item) => columnsCollection[item]);
  };
  return (
    <div>
      {fetching ? <Spin /> : null}
      {data.length > 0 ? (
        <div>
          <div>Total count: {totalCount}</div>
          <Table
            columns={renderColumns()}
            tableLayout="auto"
            dataSource={data}
            expandable={{ defaultExpandAllRows: true }}
            pagination={{
              current,
              total: totalCount,
              defaultPageSize: 20,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '30']
            }}
            onChange={onPaginationChange}
          />
        </div>
      ) : null}
      {data.length === 0 && !fetching ? <div>No record found</div> : null}
    </div>
  );
};

export default PricingOptionsTable;
